module.exports = __webpack_public_path__ + "img/bng3.54b9e0c7.png";